import { useQuery } from '@tanstack/react-query';
import { getOrders } from '../../api/orders/getOrders';

export const useGetOrders = (token: string | null) => {
  const { data, isSuccess, isLoading, isError } = useQuery({
    queryKey: ['getOrders'],
    queryFn: () => getOrders(token),
  });

  return {
    orders: data,
    isGetOrdersSuccess: isSuccess,
    isGetOrdersLoading: isLoading,
    isGetOrdersError: isError,
  };
};
